import { Contract } from "@edp-components/edp-contract/edp-contract.model";
import moment from "moment";

export interface IUserNotification {
    Id: number;
    Title: string;
    Message: string;
    Url: string;
    TemplateUrl: string;
    CreatedAt: string;
    StartDate: string;
    EndDate: string;
    Readed: {
        state: boolean;
        at: string | null;
    };
    Viewed: {
        state: boolean;
        at: string | null;
    };
    Deleted: {
        state: boolean;
        at: string | null;
    };
    UserId: number;
    ContractId: string;
    Contract?: Contract;
    Type?: string;
}

export class UserNotification {
    constructor(
        public Id: number,
        public Title: string,
        public Message: string,
        public Url: string,
        public TemplateUrl: string,
        public CreatedAt: string,
        public StartDate: string,
        public EndDate: string,
        public Readed: {
            state: boolean;
            at: string | null;
        },
        public Viewed: {
            state: boolean;
            at: string | null;
        },
        public Deleted: {
            state: boolean;
            at: string | null;
        },
        public UserId: number,
        public ContractId: string,
        public Contract: Contract,
        public Type: string
    ) {}

    public getCreatedAt(): moment.Moment {
        return this.getMomentDate(this.CreatedAt);
    }

    public getStartDate(): moment.Moment {
        return this.getMomentDate(this.StartDate);
    }

    public getEndDate(): moment.Moment {
        return this.getMomentDate(this.EndDate);
    }

    public getReaded(): moment.Moment | null {
        return this.getMomentDate(this.Readed.state);
    }

    public getDeleted(): moment.Moment | null {
        return this.Deleted.state ? moment(this.Deleted.at) : null;
    }

    public isReaded(): boolean {
        return this.Readed.state;
    }

    public isViewed(): boolean {
        return this.Viewed.state;
    }

    public isDeleted(): boolean {
        return this.Deleted.state;
    }

    public getNotificationTime() {
        const today = moment().diff(this.getStartDate(), "days") <= 1;
        return today
            ? "pt.edp.edponline.notifications.today"
            : this.getStartDate()
                  .fromNow()
                  .replace(/^há[ ]+/gi, "");
    }

    private getMomentDate(_date) {
        return _date ? moment(_date).locale("pt-pt") : null;
    }
}

export class UserNotificationFactory {
    static create(notification: IUserNotification): UserNotification {
        return new UserNotification(
            notification.Id,
            notification.Title,
            notification.Message,
            notification.Url,
            notification.TemplateUrl,
            notification.CreatedAt,
            notification.StartDate,
            notification.EndDate,
            notification.Readed,
            notification.Viewed,
            notification.Deleted,
            notification.UserId,
            notification.ContractId,
            notification.Contract,
            notification.Type
        );
    }
}
